import { type BannersList } from '@cx-web/api-clients/banners-api/types';

import BannersCarouselDesktop from './BannersCarouselDesktop';
import BannersCarouselGrid from './BannersCarouselGrid';

export interface BannersCarouselProps {
  banners: BannersList;
  interval?: number;
  /**
   * Resolved "is this the desktop layout?" — picks the carousel (desktop) vs the grid (mobile/tablet).
   * Device detection is the host's job, NOT this component's: RR7 atlas resolves it from `useMedia()`
   * (MediaProvider context); atlas-astro resolves it from `useDevice(deviceType)` (no provider in an
   * island). Keeping the booleans as props is what lets a single component serve both apps.
   */
  isDesktop: boolean;
  /** Resolved "is this the mobile bucket?" — the grid uses it to pick the small-image width. */
  isMobile: boolean;
}

// Device-agnostic page-template BANNERS_CAROUSEL — the single source of truth shared by RR7 atlas and
// atlas-astro. Both apps render this; their only component code is glue that resolves `isDesktop`/
// `isMobile` their own way and (in Astro) the island/`.astro` hydration wrapper.
export default function BannersCarousel({ banners, interval = 4000, isDesktop, isMobile }: BannersCarouselProps) {
  if (!banners || banners.length === 0) return null;

  return isDesktop ? (
    <BannersCarouselDesktop banners={banners} interval={interval} />
  ) : (
    <BannersCarouselGrid banners={banners} isMobile={isMobile} />
  );
}
